import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { KITCHEN_COLLECTIONS_LANDING_NAME } from 'landings';
import { FETCH_COLLECTIONS, ResponseCollectionList } from 'modules/collections';
import { State } from 'store/types';
import { FETCH_RELATED_SERVICES } from 'modules/related-services';
import { KitchenCollectionsRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

registerWidget<State, Record<string, string>>(`${__NAME__}/${KITCHEN_COLLECTIONS_LANDING_NAME}`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);
  if ('collectionList' in state.collections) {
    const collectionState = {
      collectionList: state.collections.collectionList,
      offset: state.collections.offset,
      productsCount: state.collections.productsCount,
      facets: state.collections.facets,
    } as ResponseCollectionList;

    store.dispatch(FETCH_COLLECTIONS.success, collectionState);
  }
  store.dispatch(FETCH_RELATED_SERVICES.success, state.relatedServices?.serviceList ?? undefined);

  return remoteProps => <KitchenCollectionsRemote router={router} store={store} {...remoteProps} />;
});
